import React from 'react';

const MAX_TEACHERS_PER_DAY = 20;

export default class Header extends React.PureComponent {
    getEventDate = () => {
        const { eventDate } = this.props;

        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        var day = eventDate.getDate();
        var monthIndex = eventDate.getMonth();
        var year = eventDate.getFullYear();

        return monthNames[monthIndex] + ' ' + day + ', ' + year;
    }

    render() {
        return (
            <div>
                <img src='/images/coaching_scheduler.png' />
                {
                    this.props.loaded && this.props.schoolName ? (
                        <div>
                            <h1 className="schoolName">{ this.props.schoolName }</h1>
                            <h1>Schedule For Coaching Event Beginning { this.getEventDate() }</h1>
                            <p>
                                Please complete your <strong>Kagan Coaching Schedule one week prior to your coaching event</strong>. Enter all information for each teacher who will be coached. Click the Save button after entering your schedule. You may also download an Excel schedule template to complete and import into this page. Click the Import Schedule button for importing instructions.
                            </p>
                            <p>
                                Please leave any special instructions for your Kagan Coach in the Notes for the Coach box below. Notes may include building names (when coaching in multiple buildings), or any other helpful information you wish to share with your Kagan Coach. 
                            </p>
                            <p>
                                If you have any questions about completing this schedule or about your Kagan Coaching event, please contact Kagan's Customer Relations department at <strong>800-451-8495</strong>.
                            </p>
                            <p>
                                The schedule below can be sorted by clicking on the <strong>Teacher First Name</strong>, <strong>Last Name</strong>, <strong>E-Mail</strong>, <strong>Date</strong> or <strong>Start Time</strong> headers.
                            </p>
                            {
                                this.props.eventDates.length * MAX_TEACHERS_PER_DAY < this.props.scheduleOrder.length ? (
                                    <p className="editBox error">
                                        You have exceeded { MAX_TEACHERS_PER_DAY } teachers in your schedule per day.
                                        <br />
                                        Please contact your Kagan coach to ensure this number of coaching visits can be completed in the allotted time.
                                    </p>
                                ) : null
                            }
                        </div>
                    ) : (
                        <div>
                            <h1 className="schoolName">
                                { this.props.error ? this.props.error : (this.props.message ? this.props.message : 'Loading Schedule...') }
                            </h1>
                            <p>
                                { this.props.error ? 'Please call Kagan Customer Support at 800-451-8495 for assistance.' : null }
                            </p>
                        </div>
                    )
                }
            </div>
        );
    }
}
